import { http as baseHttp } from '@aleph-alpha/lib-http';

const http = baseHttp({
  baseURL: '',
});

export const addBearerToken = (type, token) => {
  http.updateConfig({
    headers: {
      Authorization: `${type} ${token}`,
    },
  });
};

/**
 * The timeout for uploading large files to the server.
 * The default timeout is 10 seconds, which is not enough for large files.
 * This is a workaround to set the timeout to 2 minutes.
 * Only used for uploading large files.
 */
export const UPLOAD_TIMEOUT = 120000; // 2 minutes

export default http;
